const INIT_STATE = {
    authToken: localStorage.getItem('token')
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        default: return { ...state };
    }
}
